import axios from 'axios';
import React from 'react';
import authHeader from '../../services/auth-header';
import { config } from '../../constants';
import UserItemComponent from './UserItemComponent';
import './index.css';
import authService from '../../services/auth.service';
import i18next from 'i18next';


function closePop(){
    const pop = document.getElementById("sanctionsdocument-data-viewer")
    pop.style.display = "none"
}


export default class UsersListComponent extends React.Component{
    
    constructor(props){
        super(props);

        this.state = {
            configs:[{"a":"b"}],       
        }

        this.getLists()
    }


    getLists(){
        authService.getUserList(authHeader).then(

            response => {

                const configs = response.data;
                        
                const items = configs.map(
                    data => {
                        return <UserItemComponent data={data} setSancdocs={this.setSancdocs} />
                    }
                )

                this.setState({items:items})

            }
        )
    }

    render(){
        
    
        return(
            <div className='index-list-container'>
                <a href='/add-user' className='add-parser-page-btn'>{i18next.t("new_user")}</a>
                <div className='index-list-header'>

                    <p style={{width:"5"}}>ID</p>
                    <p style={{width:"18%"}}>Name</p>
                    <p style={{width:"18%"}}>Company Name</p>
                    <p style={{width:"18%"}}>Enabled</p>

                    <p style={{width:"10%"}}>Edit</p>
                    <p style={{width:"10%"}}>Enable/Disable</p>

                </div>

                {this.state.items}

            </div>
        );
    }
}